import React, { useState } from "react";
import LineupSummary from "./LineupSummary";
import { graphql, useLazyLoadQuery } from "react-relay";

const GET_SUMMARY = graphql`
  query LineupSummariesQuery($lineupSetID: ID!) {
    summaryForLineupSet(lineupSetId: $lineupSetID) {
      playerSummary
      stackSummary
    }
  }
`;
export default function LineupSummaries(props) {
  const [playerSummaryShow, setPlayerSummaryShow] = useState(false);
  const [stackSummaryShow, setStackSummaryShow] = useState(false);

  const data = useLazyLoadQuery(
    GET_SUMMARY,
    {
      lineupSetID: props.lineupSetId,
    },
    { fetchPolicy: "network-only", fetchKey: props.numRefetches }
  );

  function togglePlayerSummaryShow() {
    setPlayerSummaryShow(!playerSummaryShow);
  }

  function toggleStackSummaryShow() {
    setStackSummaryShow(!stackSummaryShow);
  }

  return (
    <div className="gm-lineups-summaries">
      <LineupSummary
        summaryForLineupSet={data.summaryForLineupSet}
        summaryTitle="BUILD SUMMARY"
      />

      {data.summaryForLineupSet && data.summaryForLineupSet.stackSummary ? (
        <div className="gm-lineups-summary">
          <div
            className="gm-lineup-summary-header"
            onClick={toggleStackSummaryShow}
            onKeyPress={toggleStackSummaryShow}
            role="button"
            tabIndex={0}
          >
            <div className="gm-lineup-summary-title">STACK SUMMARY</div>
            <div className="gm-lineup-toggle">
              Click To {stackSummaryShow ? "Collapse" : "Expand"}
            </div>
          </div>

          {stackSummaryShow && data.summaryForLineupSet ? (
            <div className="gm-lineup-summary-players">
              <table className="gm-lineup-summary-table">
                <thead>
                  <td>
                    <strong>Stack</strong>
                  </td>
                  <td>
                    <strong>Target Exposure</strong>
                  </td>
                  <td>
                    <strong>Actual Exposure</strong>
                  </td>
                  <td>
                    <strong>Exposure Diff</strong>
                  </td>
                </thead>
                <tbody>
                  {JSON.parse(data.summaryForLineupSet.stackSummary).map(
                    (player, index) => {
                      return (
                        <tr key={index}>
                          <td>{player[0]}</td>
                          <td>{player[1]}</td>
                          <td>{player[2]}</td>
                          <td>{player[2] - player[1]}</td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </table>
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
